<template>
    <div class="practice-plans mt-page">

        <b-button variant="primary"
                  class="float-right"
                  @click="save()">
            {{ $i18n.gt('LABEL_SAVE') }}
        </b-button>

        <h1>{{ $i18n.gt('HEADING_SELECT_PRACTICE_PLANS') }}</h1>

        <b-form-group label-cols="4"
                      :label="'Select Plans'">
            <b-form-checkbox-group stacked
                                   v-model="selectedPlanIds"
                                   :options="planList">
            </b-form-checkbox-group>
        </b-form-group>

    </div>

</template>

<script>

import Vue from 'vue'
import * as _ from 'lodash'

/**
 * Page for practitioner to manage the Plans that their Practice uses
 */
export default Vue.extend({
    name: "PracticePlans",
    props: {
        practiceId: Number
    },
    data() {
        return {
            practice: {},
            planList: [],
            selectedPlanIds: []
        }
    },
    methods: {
        async save() {
            this.practice.planPractices = _.map(this.selectedPlanIds, (plan_id) => {
                return {plan_id: plan_id, practice_id: this.practice.id}
            })
            try {
                await this.$api.updateItem(this, 'practice', this.practice)
                this.$toasted.show('Plans updated', {duration: 3000})
                // TODO: different URLs for docs vs. admins
                this.$router.push('/')
            } catch (e) {
                this.$utils.handleError(e, 'Error updating plans')
            }
        }
    },
    async mounted() {
        // load practice
        this.practice = await this.$api.getItem(this, 'practice', this.practiceId)

        // build selection model array
        this.selectedPlanIds = _.map(this.practice.planPractices, (pp) => pp.plan_id)

        const plans = await this.$api.getPlansForPractice(this, this.practice)

        this.planList = _.map(plans, (plan) => {
            return {
                value: plan.id, text: plan.name
            }
        })
    }

})
</script>
